import React, { useState } from "react";
import axios from "axios";
import * as API from "../../Endpoints/Endpoints";
import { useNavigate } from "react-router-dom";

const GameMaster = () => {
  const [formData, setFormData] = useState({
    gamecategory: "",
    gamename: "",
    gamecode: "",
    gameboardtype: "",
    complexity: "",
  });
  const [gamesymbol, setGameSymbol] = useState(null); // For image file
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleFileChange = (e) => {
    setGameSymbol(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const data = new FormData();
    for (const key in formData) {
      data.append(key, formData[key]);
    }
    if (gamesymbol) {
      data.append("gamesymbol", gamesymbol); // Append the image file
    }

    try {
      const response = await axios.post(API.POST_MASTER_API, data, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status === 201) {
        console.log("Form Data Submitted Successfully:", response.data);
        setFormData({
          gamecategory: "",
          gamename: "",
          gamecode: "",
          gameboardtype: "",
          complexity: "",
        });
        setGameSymbol(null);
        alert("Data submitted successfully!");
        navigate("/gamemastertable");
      } else {
        alert("Failed to submit data.");
      }
    } catch (error) {
      console.error("Error submitting form:", error);
      alert("An error occurred while submitting data.");
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="w-full max-w-lg p-8 bg-white rounded-lg shadow-lg">
        <h2 className="text-2xl font-bold text-center text-gray-700 mb-6">
          Game Master Form
        </h2>
        <form onSubmit={handleSubmit} encType="multipart/form-data">
          {/* Game Category Name */}
          <div className="mb-4">
            <label
              htmlFor="gamecategory"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Category Name
            </label>
            <input
              type="text"
              id="gamecategory"
              name="gamecategory"
              value={formData.gamecategory}
              onChange={handleChange}
              placeholder="Enter game category name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Name */}
          <div className="mb-4">
            <label
              htmlFor="gamename"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Name
            </label>
            <input
              type="text"
              id="gamename"
              name="gamename"
              value={formData.gamename}
              onChange={handleChange}
              placeholder="Enter game name"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Code */}
          <div className="mb-4">
            <label
              htmlFor="gamecode"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Code
            </label>
            <input
              type="text"
              id="gamecode"
              name="gamecode"
              value={formData.gamecode}
              onChange={handleChange}
              placeholder="Enter game code"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Game Symbol */}
          <div className="mb-4">
            <label
              htmlFor="gamesymbol"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Symbol (Image)
            </label>
            <input
              type="file"
              id="gamesymbol"
              name="gamesymbol"
              accept="image/*"
              onChange={handleFileChange}
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
            />
          </div>

          {/* Game Board Type */}
          <div className="mb-4">
            <label
              htmlFor="gameboardtype"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Game Board Type
            </label>
            <input
              type="text"
              id="gameboardtype"
              name="gameboardtype"
              value={formData.gameboardtype}
              onChange={handleChange}
              placeholder="Enter game board type"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Complexity */}
          <div className="mb-4">
            <label
              htmlFor="complexity"
              className="block text-sm font-medium text-gray-700 mb-1"
            >
              Complexity
            </label>
            <input
              type="text"
              id="complexity"
              name="complexity"
              value={formData.complexity}
              onChange={handleChange}
              placeholder="Enter complexity level"
              className="w-full px-4 py-2 border rounded-lg focus:ring focus:ring-[#e64a32] focus:outline-none"
              required
            />
          </div>

          {/* Submit Button */}
          <button
            type="submit"
            className="w-full bg-[#e64a32] text-white py-2 px-4 rounded-lg hover:bg-[#e64a32] focus:outline-none"
          >
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default GameMaster;
